import {
  createTableTabNavigationInput,
  type SelectionUiInteraction,
  type SharedEventLoop,
  type TableNavigationAdapter,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';

import { getExperimentValue } from '@canvas/client-feature-flags';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export interface TableTabNavigationKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  adapter: TableNavigationAdapter;
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

/**
 * Registers table Tab navigation behind the keyboard accessibility experiment.
 *
 * The feature remains table-layout scoped because it depends on visible row and
 * field ordering supplied by the Databases app adapter.
 */
export function createTableTabNavigationKeyboardInputFeature(
  deps: TableTabNavigationKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_TAB_NAVIGATION_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) => {
      if (ctx.layoutType !== DatabaseLayoutType.TABLE) {
        return false;
      }

      return (
        getExperimentValue('databasesKeyboardA11y', 'isEnabled', {
          fireExperimentExposure: false,
        }) === true
      );
    },
    factory: (machine) =>
      createTableTabNavigationInput(machine, deps.sharedLoop, {
        adapter: deps.adapter,
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
